import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Input } from '@knack/asterisk-react';

import { type EmailField } from '@/types/schema/fields';

interface EmailInputProps {
  targetField: EmailField;
  name: string;
}

export function EmailInput(props: EmailInputProps) {
  const { name, targetField } = props;
  const { register } = useFormContext();
  const [t] = useTranslation();
  const showLabelInput = targetField.format?.text_format === 'unique';
  return (
    <div className="space-y-2">
      {showLabelInput && (
        <>
          <Input
            placeholder={t('components.add_into_existing_table.enter_label')}
            {...register(`${name}.label`)}
          />
          <p className="text-sm">{t('attributes.field_labels.email.label_placeholder')}</p>
        </>
      )}
      <Input
        placeholder={t('components.add_into_existing_table.enter_email')}
        {...register(`${name}.email`)}
      />
      {showLabelInput && (
        <p className="text-sm">{t('attributes.field_labels.email.email_placeholder')}</p>
      )}
    </div>
  );
}
